import Model from 'flarum/common/Model';
export default class Passkey extends Model {
  deviceName() {
    return Model.attribute('deviceName').call(this);
  }
  aaguid() {
    return Model.attribute('aaguid').call(this);
  }
  authenticatorName() {
    return Model.attribute('authenticatorName').call(this);
  }
  transports() {
    return Model.attribute('transports').call(this);
  }
  backupEligible() {
    return Model.attribute('backupEligible').call(this);
  }
  backupState() {
    return Model.attribute('backupState').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  lastUsedAt() {
    return Model.attribute('lastUsedAt', Model.transformDate).call(this);
  }
  userAgentSummary() {
    return Model.attribute('userAgentSummary').call(this);
  }
}
flarum.reg.add('datlechin-passkey', 'common/models/Passkey', Passkey);